import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ContactUs.css';
import { LoginNavbar } from '../../components/layout/Navbar';
import { FaLinkedin, FaTwitter, FaFacebook } from "react-icons/fa";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// FIX: configure default marker icons
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const ContactUs = () => {
  const position = [43.7772294, -79.2512385]; // 200 Consilium Pl coords

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
      });

      setTimeout(() => setSubmitStatus(null), 5000);
    }, 2000);
  };

  return (
    <>
      <LoginNavbar />
      <div className="contact-container">
        <div className="contact-back-button">
          <Link to="/login" className="back-button">
            ← Back to Login
          </Link>
        </div>

        <div className="contact-hero">
          <div className="contact-hero-content">
            <h1 className="contact-title">Get in Touch</h1>
            <p className="contact-subtitle">
              We'd love to hear from you. Send us a message and we'll respond as soon as possible.
            </p>
          </div>
        </div>

        <div className="contact-content">
          {/* Left Column */}
          <div className="contact-main-column">
            <div className="contact-main">
              <h2 className="contact-section-title">Send us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label htmlFor="name" className="contact-label">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="contact-input"
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="contact-form-group">
                    <label htmlFor="email" className="contact-label">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="contact-input"
                      required
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label htmlFor="company" className="contact-label">Company</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      className="contact-input"
                      placeholder="Enter your company name"
                    />
                  </div>
                  <div className="contact-form-group">
                    <label htmlFor="subject" className="contact-label">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="contact-input"
                      required
                      placeholder="What is this about?"
                    />
                  </div>
                </div>

                <div className="contact-form-group">
                  <label htmlFor="message" className="contact-label">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="contact-textarea"
                    rows="6"
                    required
                    placeholder="Tell us more about your inquiry..."
                  ></textarea>
                </div>

                {submitStatus === 'success' && (
                  <div className="contact-success-message">
                    Thank you for your message! We'll get back to you soon.
                  </div>
                )}

                <button 
                  type="submit" 
                  disabled={isSubmitting} 
                  className="contact-submit-button"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>

            {/* Map Section */}
            <div className="contact-map-section">
              <MapContainer
                center={position}
                zoom={15}
                scrollWheelZoom={false}
                style={{ height: "300px", width: "100%", borderRadius: "12px" }}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                  url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                />
                <Marker position={position}>
                  <Popup>
                    200 Consilium Pl <br />
                    10th F <br />
                    Scarborough, ON M1H 3G2 <br />
                    Canada
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>

          {/* Sidebar */}
          <div className="contact-sidebar">
            <div className="contact-info-section">
              <h3 className="contact-info-title">Contact Information</h3>

              <div className="contact-info-item">
                <div className="contact-info-icon">📍</div>
                <div className="contact-info-content">
                  <h4>Address</h4>
                  <p>200 Consilium Pl<br />10th F<br />Scarborough, ON M1H 3G2 <br /> Canada</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">📞</div>
                <div className="contact-info-content">
                  <h4>Phone</h4>
                  <p>+1 (647) 503-7066<br />Mon-Fri: 10:00 AM - 6:00 PM EST</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">✉️</div>
                <div className="contact-info-content">
                  <h4>Email</h4>
                  <p>oseelight@gmail.com</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">🌐</div>
                <div className="contact-info-content">
                  <h4>Website</h4>
                  <p>www.oseelight.com</p>
                </div>
              </div>
            </div>

            <div className="contact-support-section">
              <h3 className="contact-support-title">Need Immediate Help?</h3>
              <p>Our support team is available to assist you with any urgent questions or technical issues.</p>
              <button className="contact-support-link">
                Need Help?
                <span className="contact-phone">📞 +1 (647) 503-7066</span>
              </button>
            </div>

            <div className="contact-social-section">
              <h3 className="contact-social-title">Follow Us</h3>
              <div className="contact-social-links">
                <a href="#" className="contact-social-link"><FaLinkedin /></a>
                <a href="#" className="contact-social-link"><FaTwitter /></a>
                <a href="#" className="contact-social-link"><FaFacebook /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer className="contact-footer" />
    </>
  );
};

export default ContactUs;